import { render, staticRenderFns } from "./SimuladoView.vue?vue&type=template&id=329975d8&scoped=true&"
import script from "./SimuladoView.vue?vue&type=script&lang=js&"
export * from "./SimuladoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329975d8",
  null
  
)

export default component.exports